import axios from "axios";
import { baseUrl } from "./api";

export const getDocumentFileId = (document) =>
  document?.file_id || document?.id || document?.document_id || null;

export const getSecureDocumentUrl = async (fileId) => {
  if (!fileId) return null;
  try {
    const token =
      localStorage.getItem("token") ||
      localStorage.getItem("auth-token") ||
      localStorage.getItem("x-auth-token");
    const response = await axios.get(`${baseUrl}/document/${fileId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response?.data?.result?.file_url || null;
  } catch (error) {
    console.error("Error fetching document URL:", error);
    return null;
  }
};

export const openSecureDocumentById = async ({ fileId, fileName, onError }) => {
  if (!fileId) {
    onError?.(`${fileName || "File"} ID is required to open securely`);
    return false;
  }

  try {
    const token =
      localStorage.getItem("token") ;

    const response = await axios.get(`${baseUrl}/document/${fileId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const signedUrl = response?.data?.result?.file_url;
    if (!signedUrl) {
      onError?.(`Unable to fetch secure URL for ${fileName || "document"}`);
      return false;
    }

    window.open(signedUrl, "_blank", "noopener,noreferrer");
    return true;
  } catch (error) {
    console.error("File open error:", error);
    onError?.(`Unable to open ${fileName || "document"}`);
    return false;
  }
};
